import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import ScrollToTop from "@/components/site/ScrollToTop";

import Home from "@/pages/Home";
import About from "@/pages/About";
import OurBrands from "@/pages/OurBrands";
import Training from "@/pages/Training";
import TRACLearn from "@/pages/TRACLearn";
import TRACCms from "@/pages/TRACCms";
import ForIndividuals from "@/pages/ForIndividuals";
import ForOrganisations from "@/pages/ForOrganisations";
import ProfessionalDevelopment from "@/pages/ProfessionalDevelopment";
import FutureDriver from "@/pages/FutureDriver";
import Glossary from "@/pages/Glossary";
import Communities from "@/pages/Communities";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import RATBAT from "@/pages/RATBAT";
import RatBatTest from "@/pages/ratbattest";
import VRTraction from "@/pages/VRTraction";
import VRPTS from "@/pages/VRPTS";
import Elearning from "@/pages/elearning";

import LMSLogin from "@/pages/LMSLogin";
import LMSAdminLogin from "@/pages/LMSAdminLogin";
import LMSChangePassword from "@/pages/LMSChangePassword";
import LMSDashboard from "@/pages/LMSDashboard";
import LMSPlatformAdmin from "@/pages/LMSPlatformAdmin";
import LMSOrganisationAdmin from "@/pages/LMSOrganisationAdmin";
import LMSCourseAuthoring from "@/pages/LMSCourseAuthoring";
import LMSCourseEditor from "@/pages/LMSCourseEditor";
import LMSCoursePlayer from "@/pages/LMSCoursePlayer";
import LMSAssessmentHub from "@/pages/LMSAssessmentHub";
import LMSAssessmentEditor from "@/pages/LMSAssessmentEditor";
import LMSCertificate from "@/pages/LMSCertificate";
import CertificateVerify from "@/pages/CertificateVerify";

import NotFound from "@/pages/NotFound";

import OrganizationSchema from "@/components/site/OrganizationSchema";
import CookieConsent from "@/components/site/CookieConsent";

function AppShell() {
  const location = useLocation();

  const isLmsRoute =
    location.pathname === "/learn" ||
    location.pathname.startsWith("/learn/");

  return (
    <>
      <ScrollToTop />

      {!isLmsRoute && <OrganizationSchema />}
      {!isLmsRoute && <Header />}

      <main id="main-content">
        <Routes>
          {/* Public website */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/our-brands" element={<OurBrands />} />
          <Route path="/training" element={<Training />} />
          <Route path="/trac-learn" element={<TRACLearn />} />
          <Route path="/trac-cms" element={<TRACCms />} />
          <Route path="/for-individuals" element={<ForIndividuals />} />
          <Route path="/for-organisations" element={<ForOrganisations />} />
          <Route
            path="/professional-development"
            element={<ProfessionalDevelopment />}
          />
          <Route path="/future-driver" element={<FutureDriver />} />
          <Route path="/glossary" element={<Glossary />} />
          <Route path="/communities" element={<Communities />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="/ratbat" element={<RATBAT />} />
          <Route path="/ratbattest" element={<RatBatTest />} />

          <Route path="/vr-traction" element={<VRTraction />} />
          <Route path="/vr-pts" element={<VRPTS />} />
          <Route path="/elearning" element={<Elearning />} />

          {/* Public certificate verification */}
          <Route
            path="/verify/certificate/:verificationCode"
            element={<CertificateVerify />}
          />

          {/* TRAC-Learn authentication */}
          <Route path="/learn/login" element={<LMSLogin />} />
          <Route path="/learn/admin/login" element={<LMSAdminLogin />} />
          <Route
            path="/learn/change-password"
            element={<LMSChangePassword />}
          />

          {/* UKTDA Super Admin */}
          <Route path="/learn/admin" element={<LMSPlatformAdmin />} />

          <Route
            path="/learn/admin/courses"
            element={<LMSCourseAuthoring />}
          />

          <Route
            path="/learn/admin/courses/:courseId"
            element={<LMSCourseEditor />}
          />

          <Route
            path="/learn/admin/assessments"
            element={<LMSAssessmentHub />}
          />

          <Route
            path="/learn/admin/assessments/:activityId"
            element={<LMSAssessmentEditor />}
          />

          <Route
            path="/learn/admin/organisations/:organisationId"
            element={<LMSOrganisationAdmin />}
          />

          {/* Organisation administration */}
          <Route
            path="/learn/organisations/:organisationId"
            element={<LMSOrganisationAdmin />}
          />

          {/* Learner course delivery */}
          <Route
            path="/learn/course/:enrolmentId"
            element={<LMSCoursePlayer />}
          />

          <Route
            path="/learn/certificate/:enrolmentId"
            element={<LMSCertificate />}
          />

          {/* Learner dashboard */}
          <Route path="/learn" element={<LMSDashboard />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {!isLmsRoute && <Footer />}
      {!isLmsRoute && <CookieConsent />}

      <Toaster position="top-right" richColors closeButton />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </div>
  );
}

export default App;